import React, { useRef } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Content from "../ScreenComponents/Content";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { List, ListItemText, ListItem, ListItemIcon } from "@material-ui/core";
import { Button } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { useReactToPrint } from "react-to-print";
import Printout from "../../Printout/Printout";
import GeneralTips from "../ScreenComponents/GeneralTips";
import ContractTips from "../ScreenComponents/ContractTips";
import TailoringTipView from "../ScreenComponents/TailoringTipView";
import { Checkbox } from "@material-ui/core";
import { FormGroup, FormControlLabel } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  toolbar: {
    //paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "centers",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appToolbar: {
    [theme.breakpoints.up("sm")]: {
      alignItems: "center",
      width: "100%",
      background: theme.primary,
      //marginLeft: "15%",
      //width: `calc(100% - ${DrawerWidth}px)`,
      //marginLeft: DrawerWidth,
    },
  },
  nestedAppToolbar: {
    [theme.breakpoints.up("sm")]: {
      alignItems: "center",
      color: "white",
      width: "50%",
      marginLeft: "25%",
      marginRight: "25%",
      background: "#3374b2",
      //width: `calc(100% - ${DrawerWidth}px)`,
      //marginLeft: DrawerWidth,
    },
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
  },
  tacticContainer: {
    justifyContent: "center",
    alignItems: "center",
    direction: "row",
    spacing: 2,
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    //width: "100%",
  },
  fixedHeight: {
    height: 300,
  },
  balanceCard: {
    height: 400,
    //width: "100%",
    //width: 500,
  },
  column: {
    flexBasis: "33%",
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export function Dashboard(props) {
  const classes = useStyles();
  //const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  const balancePaper = clsx(classes.paper, classes.balanceCard);
  const [value, setValue] = React.useState(0);
  const [tailorValue, setTailorValue] = React.useState(0);
  const [printApproach, approachPrint] = React.useState(0);
  const [printPathway, pathwayPrint] = React.useState(0);
  const [printContract, contractPrint] = React.useState(0);
  const [printTailor, tailorPrint] = React.useState(0);
  const {
    values: { projectName, projectNature },
  } = props;

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const setPathway = (val) => {
    pathwayPrint(val.target.checked);
    props.currentContext.printOptions["pathway"] = val.target.checked;
    // this.props.currentContext.setContract(val.target.checked, approach);
  };
  const setApproach = (val) => {
    approachPrint(val.target.checked);
    props.currentContext.printOptions["approach"] = val.target.checked;
    // this.props.currentContext.setContract(val.target.checked, approach);
  };
  const setContract = (val) => {
    contractPrint(val.target.checked);
    props.currentContext.printOptions["contract"] = val.target.checked;
    // this.props.currentContext.setContract(val.target.checked, approach);
  };
  const setTailor = (val) => {
    tailorPrint(val.target.checked);
    props.currentContext.printOptions["tailor"] = val.target.checked;
    // this.props.currentContext.setContract(val.target.checked, approach);
  };

  const tailoringArrayGenerator = (passedDict, selections) => {
    let newArray = [];
    Object.keys(passedDict).forEach(function (key) {
      if (selections[key]) {
        //
        newArray.push(key);
      }
    });
    return newArray;
    // get for a specific tailoring dictionary
  };

  let tailoringChoicesDict = props.currentContext.tailoringChoice;

  let tailoringDict = props.currentContext.getTailoringChoice();

  let statutoryDict = tailoringDict["Statutory"];
  let exceptionDict = tailoringDict["Exception"];
  let regulatoryDict = tailoringDict["Regulatory"];
  /*
  let selectedStatutory = Object.keys(statutoryDict);
  let selectedExceptions = Object.keys(exceptionDict);
  let selectedRegulatory = Object.keys(regulatoryDict);
  */

  let selectedStatutory = tailoringArrayGenerator(
    statutoryDict,
    tailoringChoicesDict["Statutory"]
  );
  let selectedExceptions = tailoringArrayGenerator(
    exceptionDict,
    tailoringChoicesDict["Exception"]
  );
  let selectedRegulatory = tailoringArrayGenerator(
    regulatoryDict,
    tailoringChoicesDict["Regulatory"]
  );

  let tailoringPayloadArrays = [
    selectedStatutory,
    selectedExceptions,
    selectedRegulatory,
  ];

  let tailoringPayloadDicts = [statutoryDict, exceptionDict, regulatoryDict];

  let approachList = Object.keys(props.currentContext.approachDescriptions);

  let getDescription = (curDict) => {
    return curDict["Resources"];
  };

  let getRecommended = (curDict) => {
    return curDict["Recommended Tips"];
  };

  let getNotRecommended = (curDict) => {
    return curDict["Not-Recommended Tips"];
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleTailorChange = (event, newValue) => {
    setTailorValue(newValue);
  };

  const prevPage = (e) => {
    e.preventDefault();
    props.prevStep();
  };

  return (
    <>
      <Content>
        <Grid
          item
          xs={12}
          style={{
            paddingBottom: 10,
            paddingLeft: "25%",
            paddingRight: "25%",
          }}
        >
          <div style={{ display: "none" }}>
            <Printout
              tailoringPayloadArrays={tailoringPayloadArrays}
              tailoringPayloadDicts={tailoringPayloadDicts}
              currentContext={props.currentContext}
              ref={componentRef}
            />
          </div>
          <Button
            fullWidth
            color="secondary"
            variant="contained"
            onClick={handlePrint}
          >
            Print Results
          </Button>
        </Grid>
        <Paper>
          <AppBar
            color="secondary"
            position="static"
            className={classes.appToolbar}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="simple tabs"
            >
              <Tab label="Confirm Your Selections" />
              <Tab label="Pathway Tips" />
              <Tab label="Approach Tactics" />
              <Tab label="Contracting Tips" />
              <Tab label="Tailoring Recommendations" />
            </Tabs>
          </AppBar>

          <TabPanel value={value} index={0}>
            <Grid
              container
              xs={12}
              spacing={4}
              direction="row"
              style={{
                justifyContent: "space-around",
                alignItems: "flex-start",
              }}
            >
              <Grid
                item
                xs={2}
                spacing={4}
                direction="row"
                style={{
                  justifyContent: "space-around",
                  alignItems: "flex-start",
                }}
              >
                Printout Options:
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={setPathway}
                        checked={props.currentContext.printOptions["pathway"]}
                      />
                    }
                    label="Pathway Tips"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={setApproach}
                        checked={props.currentContext.printOptions["approach"]}
                      />
                    }
                    label="Approach Tactics"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={setContract}
                        checked={props.currentContext.printOptions["contract"]}
                      />
                    }
                    label="Contract Tips"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={setTailor}
                        checked={props.currentContext.printOptions["tailor"]}
                      />
                    }
                    label="Tailoring Recommendations"
                  />
                </FormGroup>
              </Grid>
              <Grid
                item
                container
                xs={10}
                spacing={4}
                direction="row"
                style={{
                  justifyContent: "space-around",
                  alignItems: "flex-start",
                }}
              >
                <Grid item xs={4}>
                  <List>
                    <ListItem>
                      <ListItemText
                        primary="Project Name:"
                        secondary={projectName}
                      />
                    </ListItem>
                  </List>
                </Grid>
                <Grid item xs={4}>
                  <List>
                    <ListItem>
                      <ListItemText
                        primary="Project Nature:"
                        secondary={
                          props.currentContext.natureDescriptions[projectNature]
                        }
                      />
                    </ListItem>
                  </List>
                </Grid>
                <Grid item xs={4}>
                  <List>
                    <ListItem>
                      <ListItemText
                        primary="Acquisition Pathway Choice:"
                        secondary={props.currentContext.getFullPathwayName()}
                      />
                    </ListItem>
                  </List>
                </Grid>
                <Grid item xs={4}>
                  <List>
                    <ListItem>
                      <ListItemText
                        primary="Urgent Project"
                        secondary={props.currentContext.getUrgencyText()}
                      />
                    </ListItem>
                  </List>
                </Grid>
                <Grid item xs={4}>
                  <List>
                    <ListItem>
                      <ListItemText
                        primary="DBS Project:"
                        secondary={props.currentContext.getDBSText()}
                      />
                    </ListItem>
                  </List>
                </Grid>
                <Grid item xs={4}>
                  <List>
                    <ListItem>
                      <ListItemText
                        primary="ACAT:"
                        secondary={props.currentContext.EstCosts}
                      />
                    </ListItem>
                  </List>
                </Grid>

                <Grid item xs={3}></Grid>
              </Grid>
              <Grid
                container
                item
                xs={12}
                spacing={3}
                style={{ justifyContent: "center", alignItems: "flex-start" }}
              >
                <Grid item xs={4}>
                  Selected Approaches:
                </Grid>
                <Grid item xs={4}>
                  Selected Contracts:
                </Grid>
                <Grid item xs={4}>
                  Selected Tailoring Options:
                </Grid>
                <Grid item xs={4}>
                  <List>
                    {approachList.map((elem) => (
                      <div>
                        {props.currentContext.approachChoice[elem] && (
                          <ListItem key={approachList.indexOf(elem)}>
                            <ListItemText primary={elem} />
                          </ListItem>
                        )}
                      </div>
                    ))}
                  </List>
                </Grid>
                <Grid item xs={4}>
                  <List>
                    {props.currentContext.contractNames.map((elem) => (
                      <div>
                        {props.currentContext.contractChoice[elem] && (
                          <ListItem
                            key={props.currentContext.contractNames.indexOf(
                              elem
                            )}
                          >
                            <ListItemText primary={elem} />
                          </ListItem>
                        )}
                      </div>
                    ))}
                  </List>
                </Grid>
                <Grid item xs={4}>
                  <List>
                    {selectedStatutory.map((elem) => (
                      <div>
                        <ListItem key={selectedStatutory.indexOf(elem)}>
                          <ListItemText primary={elem} />
                        </ListItem>
                      </div>
                    ))}
                  </List>
                </Grid>
              </Grid>
            </Grid>
          </TabPanel>

          <TabPanel value={value} index={1}>
            <GeneralTips currentContext={props.currentContext} />
          </TabPanel>

          <TabPanel value={value} index={2}>
            <Grid
              container
              item
              xs={12}
              spacing={2}
              //className={classes.tacticContainer}
            >
              <Grid item xs={12} style={{ textAlign: "center" }}>
                <h2>Keep these tips in mind when applying your approaches</h2>
              </Grid>

              {approachList.map(
                (elem) =>
                  props.currentContext.approachChoice[elem] && (
                    <Grid item xs={6} key={approachList.indexOf(elem)}>
                      <Typography align="center">{elem}</Typography>
                      <Paper className={balancePaper}>
                        <Grid item xs={12}>
                          <div className={classes.column}>
                            <List dense>
                              <ListItem>
                                <ListItemText
                                  primary={getDescription(
                                    props.currentContext.approachDescriptions[
                                      elem
                                    ]
                                  )}
                                />
                              </ListItem>
                            </List>
                          </div>
                        </Grid>
                        <Grid item container xs={12}>
                          <Grid item xs={6}>
                            <div className={clsx(classes.column)}>
                              <List dense>
                                {getRecommended(
                                  props.currentContext.approachDescriptions[
                                    elem
                                  ]
                                ).map((recommended) => (
                                  <ListItem
                                    key={getRecommended(
                                      props.currentContext.approachDescriptions[
                                        elem
                                      ]
                                    ).indexOf(recommended)}
                                  >
                                    <ListItemIcon>
                                      <AddIcon />
                                    </ListItemIcon>
                                    <ListItemText primary={recommended} />
                                  </ListItem>
                                ))}
                              </List>
                            </div>
                          </Grid>
                          <Grid item xs={6}>
                            <div className={clsx(classes.column)}>
                              <List dense>
                                {getNotRecommended(
                                  props.currentContext.approachDescriptions[
                                    elem
                                  ]
                                ).map((notRecommended) => (
                                  <ListItem
                                    key={getNotRecommended(
                                      props.currentContext.approachDescriptions[
                                        elem
                                      ]
                                    ).indexOf(notRecommended)}
                                  >
                                    <ListItemIcon>
                                      <RemoveIcon />
                                    </ListItemIcon>
                                    <ListItemText primary={notRecommended} />
                                  </ListItem>
                                ))}
                              </List>
                            </div>
                          </Grid>
                        </Grid>
                      </Paper>
                    </Grid>
                  )
              )}
            </Grid>
          </TabPanel>
          <TabPanel value={value} index={3}>
            <ContractTips
              currentContext={props.currentContext}
              balancePaper={balancePaper}
            />
          </TabPanel>
          <TabPanel value={value} index={4}>
            <Grid
              container
              item
              xs={12}
              centered
              //style={{
              //direction: "row",
              //justifyContent: "center",
              //alignItems: "center",
              //}}
              spacing={2}
            >
              <Grid item xs={12} style={{ textAlign: "center" }}>
                <h2>Tailoring Tips</h2>
              </Grid>
              <Grid item xs={12}>
                <AppBar
                  color="secondary"
                  position="static"
                  className={classes.nestedAppToolbar}
                >
                  <Tabs
                    value={tailorValue}
                    onChange={handleTailorChange}
                    aria-label="simple tabs"
                  >
                    <Tab label="Statutory" />
                    <Tab label="Statutory with Exceptions" />
                    <Tab label="Regulatory" />
                  </Tabs>
                </AppBar>
              </Grid>

              <TabPanel value={tailorValue} index={0}>
                <Grid item container xs={12}>
                  {selectedStatutory.map((elem) => (
                    <TailoringTipView
                      elem={elem}
                      tailoringDict={statutoryDict}
                      classes={classes}
                    />
                  ))}
                </Grid>
              </TabPanel>
              <TabPanel value={tailorValue} index={1}>
                <Grid item container xs={12}>
                  {selectedExceptions.map((elem) => (
                    <TailoringTipView
                      elem={elem}
                      tailoringDict={statutoryDict}
                      classes={classes}
                    />
                  ))}
                </Grid>
              </TabPanel>
              <TabPanel value={tailorValue} index={2}>
                <Grid item container xs={12}>
                  {selectedRegulatory.map((elem) => (
                    <TailoringTipView
                      elem={elem}
                      tailoringDict={statutoryDict}
                      classes={classes}
                    />
                  ))}
                </Grid>
              </TabPanel>
            </Grid>
          </TabPanel>
        </Paper>
        <Grid item container spacing={1}>
          <Grid item xs={12}>
            <Button
              fullWidth
              color="secondary"
              variant="contained"
              onClick={prevPage}
            >
              Back
            </Button>
          </Grid>
          <Grid item xs={12}>
            <div style={{ display: "none" }}>
              <Printout
                tailoringPayloadArrays={tailoringPayloadArrays}
                tailoringPayloadDicts={tailoringPayloadDicts}
                currentContext={props.currentContext}
                ref={componentRef}
              />
            </div>
          </Grid>
        </Grid>
      </Content>
    </>
  );
}
